// Mock data for Shopify products - organized by protocol categories

export const mockProducts = {
  perimenopause: [],
  fitness: [
    {
      id: 'fit-1',
      title: 'Daily Aminos+',
      handle: 'daily-aminos',
      description: 'Essential Amino Acids + Taurine + Electrolytes. High concentration of leucine, 5g of Amino Acids per serving. Supports Muscle Protein Synthesis.',
      price: '49.88',
      compareAtPrice: '59.99',
      image: 'https://www.mdlogichealth.com/cdn/shop/files/dailyaminosproductPhoto_4.png?w=600&h=600&fit=crop',
      rating: 4.8,
      reviews: 28,
      tags: ['amino acids', 'muscle', 'energy'],
      vendor: 'Ideal Age'
    },
    {
      id: 'fit-2',
      title: 'Daily Creatine+',
      handle: 'daily-creatine',
      description: '3g Water-Washed, Micronized Creatine Monohydrate per serving. 2g Inositol + 500mg Taurine. Supports muscle strength, cognitive function, and mood.',
      price: '44.50',
      compareAtPrice: '54.99',
      image: 'https://www.mdlogichealth.com/cdn/shop/files/Daily_Creatine_product_Photo_1296x.png?w=600&h=600&fit=crop',
      rating: 4.9,
      reviews: 3,
      tags: ['creatine', 'strength', 'cognitive'],
      vendor: 'Ideal Age'
    },
    {
      id: 'fit-3',
      title: 'Whey Protein',
      handle: 'whey-protein',
      description: 'Grass-fed whey protein isolate. Low lactose, high protein content for muscle recovery and growth.',
      price: '52.00',
      compareAtPrice: null,
      image: 'https://www.mdlogichealth.com/cdn/shop/files/Whey_Protein_Isolate_Product_Photo.png?w=600&h=600&fit=crop',
      rating: 4.7,
      reviews: 89,
      tags: ['protein', 'muscle', 'recovery'],
      vendor: 'MD Logic Health'
    }
  ],
  antiAging: [
    {
      id: 'anti-1',
      title: 'Marine Collagen',
      handle: 'marine-collagen',
      description: 'Wild-caught marine collagen peptides. Supports skin elasticity, joint health, and hair & nail growth.',
      price: '54.00',
      compareAtPrice: null,
      image: 'https://www.mdlogichealth.com/cdn/shop/files/coq10-product-photo_1296x.png?w=600&h=600&fit=crop',
      rating: 4.9,
      reviews: 112,
      tags: ['collagen', 'skin', 'joints'],
      vendor: 'MD Logic Health'
    },
    {
      id: 'anti-2',
      title: 'CoQ10',
      handle: 'coq10',
      description: 'Ubiquinol form for maximum absorption. Supports heart health, cellular energy, and antioxidant protection.',
      price: '48.00',
      compareAtPrice: null,
      image: 'https://www.mdlogichealth.com/cdn/shop/files/coq10-product-photo_1296x.png?w=600&h=600&fit=crop',
      rating: 4.8,
      reviews: 67,
      tags: ['heart health', 'energy', 'antioxidant'],
      vendor: 'MD Logic Health'
    },
    {
      id: 'anti-3',
      title: 'Glucose Defend',
      handle: 'glucose-defend',
      description: 'Blood sugar support formula. Helps maintain healthy glucose levels and metabolic function.',
      price: '44.00',
      compareAtPrice: null,
      image: 'https://www.mdlogichealth.com/cdn/shop/files/glucosedefendfront_1296x.png?w=600&h=600&fit=crop',
      rating: 4.6,
      reviews: 47,
      tags: ['blood sugar', 'metabolism', 'wellness'],
      vendor: 'MD Logic Health'
    }
  ],
  mindMood: [
    {
      id: 'mind-1',
      title: 'Good Mood',
      handle: 'good-mood',
      description: 'Nervous system and mood balance support. Natural ingredients to promote emotional wellness and calm.',
      price: '34.00',
      compareAtPrice: null,
      image: 'https://www.mdlogichealth.com/cdn/shop/files/GoodMood2_1296x.png?w=600&h=600&fit=crop',
      rating: 4.7,
      reviews: 78,
      tags: ['mood', 'stress', 'calm'],
      vendor: 'MD Logic Health'
    },
    {
      id: 'mind-2',
      title: 'Daily Creatine+',
      handle: 'daily-creatine',
      description: '3g Water-Washed, Micronized Creatine Monohydrate per serving. 2g Inositol + 500mg Taurine. Supports muscle strength, cognitive function, and mood.',
      price: '44.50',
      compareAtPrice: '54.99',
      image: 'https://www.mdlogichealth.com/cdn/shop/files/Daily_Creatine_product_Photo_1296x.png?w=600&h=600&fit=crop',
      rating: 4.9,
      reviews: 3,
      tags: ['creatine', 'strength', 'cognitive'],
      vendor: 'Ideal Age'
    },
    {
      id: 'mind-3',
      title: 'More Chill Magnesium',
      handle: 'more-chill-magnesium',
      description: 'Premium magnesium blend for relaxation and stress support. Helps promote calm and restful sleep.',
      price: '38.00',
      compareAtPrice: null,
      image: 'https://www.mdlogichealth.com/cdn/shop/files/morechillmagproductPhoto_1.png?w=600&h=600&fit=crop',
      rating: 4.7,
      reviews: 42,
      tags: ['magnesium', 'relaxation', 'sleep'],
      vendor: 'Well Minerals'
    }
  ],
  immuneSupport: [
    {
      id: 'immune-1',
      title: 'Immuno Logic',
      handle: 'immuno-logic',
      description: 'Next level immune support. A complex team of nutrients working in harmony to boost your immune system.',
      price: '46.00',
      compareAtPrice: null,
      image: 'https://www.mdlogichealth.com/cdn/shop/products/immunoproductPhoto_1296x.png?w=600&h=600&fit=crop',
      rating: 4.9,
      reviews: 134,
      tags: ['immune', 'wellness', 'defense'],
      vendor: 'MD Logic Health'
    },
    {
      id: 'immune-2',
      title: 'Colostrum',
      handle: 'colostrum',
      description: 'Optimized for absorption. Supports immune function, gut health, and athletic recovery.',
      price: '68.50',
      compareAtPrice: null,
      image: 'https://www.mdlogichealth.com/cdn/shop/files/colostrumproductPhoto_4_1296x.png?w=600&h=600&fit=crop',
      rating: 4.8,
      reviews: 91,
      tags: ['colostrum', 'gut health', 'recovery'],
      vendor: 'MD Logic Health'
    },
    {
      id: 'immune-3',
      title: 'D3+K2',
      handle: 'd3-k2',
      description: 'Synergistic vitamin duo for bone health and immune support. Optimal absorption formula.',
      price: '32.00',
      compareAtPrice: null,
      image: 'https://www.mdlogichealth.com/cdn/shop/files/d3k2productPhoto_1296x.png?w=600&h=600&fit=crop',
      rating: 4.7,
      reviews: 63,
      tags: ['vitamin d', 'vitamin k', 'bones'],
      vendor: 'MD Logic Health'
    }
  ],
  digestiveBloodSugar: [],
  bodyRecomp: [],
  bodyRecompPhase2: []
};

export const testimonials = [
  {
    id: 1,
    name: 'Sarah M.',
    role: 'Verified Buyer',
    content: 'The Daily Aminos+ has completely transformed my energy levels. I feel stronger during my workouts and recover so much faster.',
    product: 'Daily Aminos+',
    rating: 5
  },
  {
    id: 2,
    name: 'Sandra V.',
    role: 'Verified Buyer',
    content: "I've been taking Daily Creatine+ for a month now and have noticed that my post-workout recovery is quicker. I'm not as sore as I used to be. I also notice that I don't experience an upset stomach with this brand like I have with other brands.",
    product: 'Daily Creatine+',
    rating: 5
  },
  {
    id: 3,
    name: 'Michael R.',
    role: 'Verified Buyer',
    content: 'Marine Collagen has done wonders for my skin and joints. At 50, I feel like I have the energy of my 30s.',
    product: 'Marine Collagen',
    rating: 5
  }
];

export const protocolInfo = {
  perimenopause: {
    name: 'Perimenopause',
    tagline: 'Support your mental and physical well-being after 40.',
    description: 'Core formulas and targeted ingredients to nourish and support your body at all stages.',
    color: '#EC407A'
  },
  fitness: {
    name: 'Fitness & Metabolism',
    tagline: 'Promote muscle, metabolism, and recovery with formulas made for women.',
    description: 'Support your active lifestyle with targeted supplements designed to enhance muscle development, boost metabolism, and accelerate recovery.',
    color: '#E57373'
  },
  antiAging: {
    name: 'Anti-Aging',
    tagline: 'Support a healthy, resilient body, now and for good.',
    description: 'Premium formulas to support cellular health, skin vitality, and longevity from the inside out.',
    color: '#9575CD'
  },
  mindMood: {
    name: 'Mind & Mood',
    tagline: 'Support a sharp mind and a positive mood.',
    description: 'Nourish your cognitive function and emotional wellness with clinically-studied ingredients.',
    color: '#64B5F6'
  },
  immuneSupport: {
    name: 'Immune Support',
    tagline: 'Must-haves for a healthy immune response.',
    description: 'Strengthen your body\'s natural defenses with powerful immune-boosting nutrients.',
    color: '#81C784'
  },
  digestiveBloodSugar: {
    name: 'Digestive & Blood Sugar Support',
    tagline: 'Support healthy digestion and balanced blood sugar.',
    description: 'Targeted formulas to aid digestion, nutrient absorption, and maintain healthy glucose levels.',
    color: '#FFB74D'
  },
  bodyRecomp: {
    name: 'Body Recomp Done Right (Phase 1)',
    tagline: 'The foundational stack for BRDR Phase 1: Reset.',
    description: 'We keep this phase simple with vitamin C and magnesium for stress and recovery support; and amino acids, creatine, and protein to support recovery and lean muscle.',
    color: '#26A69A'
  },
  bodyRecompPhase2: {
    name: 'Body Recomp Done Right (Phase 2)',
    tagline: 'The foundational stack for BRDR Phase 2: Recomp.',
    description: 'All the same supplements from Phase 1 PLUS vitamin D2+K2, with a stronger emphasis on creatine and amino acids as must-haves for supporting muscle growth and recovery.',
    color: '#26A69A'
  }
};

// Legacy export for backwards compatibility
export const brandInfo = protocolInfo;
